// Солвер капчи регистрирует платформа (web — cap-widget, native — скрытый WebView).
// Возвращает одноразовый токен или null, если капча не настроена или не решилась.
type CaptchaSolver = () => Promise<string | null>

let captchaSolver: CaptchaSolver | null = null

export const setCaptchaSolver = (solver: CaptchaSolver | null): void => {
  captchaSolver = solver
}

export const getCaptchaSolver = (): CaptchaSolver | null => captchaSolver
